function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { SvgIcon } from '@material-ui/core';
export default function CameraIcon(props) {
  let output = /*#__PURE__*/React.createElement(SvgIcon, _extends({
    viewBox: "0 0 512 512"
  }, props), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m391 286c0-24.814-20.186-45-45-45h-300c-24.814 0-46 20.186-46 45v150c0 24.814 21.186 45 46 45h300c24.814 0 45-20.186 45-45v-15h30v-120h-30zm-180 120c0 8.291-6.709 15-15 15h-120c-8.291 0-15-6.709-15-15v-60c0-8.291 6.709-15 15-15h120c8.291 0 15 6.709 15 15zm45-75c-8.284 0-15-6.716-15-15 0-8.286 6.716-15 15-15s15 6.714 15 15c0 8.284-6.716 15-15 15zm60 0c-8.284 0-15-6.716-15-15 0-8.286 6.716-15 15-15s15 6.714 15 15c0 8.284-6.716 15-15 15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m91 361h90v30h-90z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m497 271h-15c-16.569 0-31 13.431-31 30v120c0 16.567 14.431 30 31 30h15c8.284 0 15-6.716 15-15v-150c0-8.286-6.716-15-15-15z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "91",
    cy: "121",
    r: "15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 121c0 49.706 41.294 90 91 90s90-40.294 90-90-40.294-90-90-90-91 40.294-91 90zm136 0c0 24.814-20.186 45-45 45s-45-20.186-45-45 20.186-45 45-45 45 20.186 45 45z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "301",
    cy: "121",
    r: "15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m391 121c0-49.706-40.294-90-90-90s-90 40.294-90 90 40.294 90 90 90 90-40.294 90-90zm-135 0c0-24.814 20.186-45 45-45s45 20.186 45 45-20.186 45-45 45-45-20.186-45-45z"
  })));
  return output;
}
